import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function LineUserSquareIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M14.81 12.28a3.7298 3.7298 0 0 0 1-2.5 3.7799 3.7799 0 1 0-7.56 0 3.73 3.73 0 0 0 1 2.5A5.94 5.94 0 0 0 6 16.89a1.006 1.006 0 1 0 2 .22 3.9998 3.9998 0 0 1 3.97-3.511 3.9999 3.9999 0 0 1 3.97 3.511A.9999.9999 0 0 0 17 18h.11a1.0006 1.0006 0 0 0 .6666-.3687A1.0003 1.0003 0 0 0 17.99 16.9a5.9395 5.9395 0 0 0-3.18-4.62ZM12 11.56a1.7797 1.7797 0 0 1-1.6445-1.0988 1.7802 1.7802 0 0 1 2.3257-2.3257A1.7803 1.7803 0 0 1 13.78 9.78 1.78 1.78 0 0 1 12 11.56ZM19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 17a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14Z"/>
  </SvgIcon>
}

export default LineUserSquareIcon
